import { gql } from "@apollo/client";

export const GET_SCHEDULE_CLASS_QUERY = gql`
    query ScheduleClass($scheduleItemId: ID!, $date: Date!) {
        scheduleClass(scheduleItemId: $scheduleItemId, date: $date) {
            scheduleItemId
            frequencyType
            date
            organizationClasstype {
                name
            }
            organizationLocationRoom {
                organizationLocation {
                    name
                }
            }
            timeStart
            timeEnd
            infoMailContent
            userBookingStatus
            userAttendanceId
            isUserOnWaitlist
            userWaitlistPosition
            canJoinWaitlist
            userWaitlistAttendanceId
            waitlistEnabled
            waitlistCount
            hasWaitlist
        }
    }
`;
